// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-toolbar {
  --border-color: var(--ion-color-danger) !important;
  --border-width: 0 0 3px 0 !important;
}

.toolbar-title {
  padding-inline: 0px;
  margin-left: 65px;
}

.no-maps-container {
  display: flex;
  justify-content: center;
  height: 100%;
  align-items: center;
  text-align: center;
  padding: 0 20px;
}`, "",{"version":3,"sources":["webpack://./src/app/modals/add-favorite-maps-modal/add-favorite-maps-modal.component.scss"],"names":[],"mappings":"AAAA;EACE,kDAAA;EACA,oCAAA;AACF;;AAEA;EACE,mBAAA;EACA,iBAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AACF","sourcesContent":["ion-toolbar {\n  --border-color: var(--ion-color-danger) !important;\n  --border-width: 0 0 3px 0 !important;\n}\n\n.toolbar-title {\n  padding-inline: 0px;\n  margin-left: 65px;\n}\n\n.no-maps-container {\n  display: flex;\n  justify-content: center;\n  height: 100%;\n  align-items: center;\n  text-align: center;\n  padding: 0 20px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
